import React from 'react'
import { Typography } from '@mui/material'
import { string } from 'prop-types'

const LineSplit = ({ string, separator, regexSeparator }) =>
  string.split(regexSeparator || separator).map((line, index) => (
    <Typography variant="body2" component="p" key={index}>
      {line}
    </Typography>
  ))

LineSplit.propTypes = {
  string: string,
  separator: string,
}

export default LineSplit
